export async function uploadVersionAndRefresh(
  file: File,
  upload: (file: File) => Promise<unknown>,
  refresh: () => Promise<unknown>,
): Promise<void> {
  await upload(file);
  await refresh();
}
